module.exports = __webpack_public_path__ + "static/livechat-customize-chat-widget-og-image-e64312f2258f0356c4c50eb6db3bcd24.png";